<template>
    <div class="login">
        <div class="logo">
            <img class="logo" src="../assets/icons/propmate_logo.png" />
        </div>
        <div class="login-text">
          Login to you account to continue
        </div>
        <div class="form-container">
         <Login />
         </div>
    </div>
</template>
<script>
import Login from "../views/Login";
export default {
  name: "Home",
  components: {
    Login
  },
}
</script>
<style lang="scss" scoped>
@import "../styles/_variables";
$colorPink: #f4e8e5;
$colorRed: #fc5657;
.login{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items:center;
    background-image: linear-gradient(to bottom, $colorRed 30%, $colorPink 30%);
    .logo{
        max-width: 250px;
        margin-top: 25px;
        padding-right: 5px;
    }
    .login-text {
        font-family: Inter-Regular;
        font-size: 14px;
        color: #fff;
        letter-spacing: 0;
        line-height: 30px;
        font-weight: 500;
        margin-top: 10px;
    }
    .form-container{
        margin-top: 30px;
        background-color: white;
        box-shadow: 0px 1px 30px 0 rgba(0,0,0,0.08);
        min-width: 600px;
        padding: 35px 80px;
    }
}
</style>